// extracted by mini-css-extract-plugin
export default {"loader_container":"MediumLoader_loader_container__v4uP4","loader":"MediumLoader_loader__-UVC8","spinner-c7wet2":"MediumLoader_spinner-c7wet2__jSPbG"};